import styles from "./player-stats.module.css";

import { useAuth } from "../../../context/AuthContext";
import XpStatus from "../../../XpSystem/XpStatus";

export default function PlayerStats() {
  const { user } = useAuth();

  const playerData = {
    username: user?.name || "Player",
    pixelId: user?.id?.slice(-8).toUpperCase() || "PM-0000",
    level: user?.level || 1,
    xp: user?.xp || 0,
    xpProgress: user?.xpProgress || 0,
    vipTier: user?.vip?.tier?.name || "None",
    vipProgress: 0, // Could be calculated if needed
  };

  return (
    <div className={styles.statsCard}>
      <div className={styles.header}>
        <div className={styles.playerInfo}>
          <div className={styles.avatar}>👾</div>
          <div className={styles.info}>
            <h3 className={styles.username}>{playerData.username}</h3>
            <p className={styles.pixelId}>{playerData.pixelId}</p>
          </div>
        </div>
        <div className={styles.vipBadge}>
          <span className={styles.vipLabel}>{playerData.vipTier}</span>
        </div>
      </div>

      <div className={styles.statsGrid}>
        <div className={styles.statItem}>
          <XpStatus
            xp={playerData.xp}
            level={playerData.level}
            xpProgress={playerData.xpProgress}
            className="!bg-transparent !border-0 !shadow-none !p-0"
          />
        </div>
        <div className={styles.statItem} style={{ gridColumn: "span 2" }}>
          <label className={styles.statLabel}>VIP Progress</label>
          <div className={styles.progressBar}>
            <div
              className={styles.progressFill}
              style={{ width: `${playerData.vipProgress}%` }}
            />
          </div>
          <p className={styles.progressText}>{playerData.vipProgress}%</p>
        </div>
      </div>
    </div>
  );
}
